import callApi from '../../util/apiCaller';

export const CUSTOM_META_FETCH_ALL = 'CUSTOM_META_FETCH_ALL';
export const CUSTOM_META_ADD_NEW_META = 'CUSTOM_META_ADD_NEW_META';
export const CUSTOM_META_DELETE_META = 'CUSTOM_META_DELETE_META';

export function fetchAllMetas() {
  const emptyState = {
    status: null,
    errors: null,
    metas: [],
    indexedMetas: {},
  };
  return (dispatch) => {
    dispatch({
      ...emptyState,
      type: CUSTOM_META_FETCH_ALL,
      status: 'loading',
      errors: null,
    });
    const p = new Promise((resolve, reject) => {
      callApi('custom-metas', 'GET').then(
        (res) => {
          dispatch({
            ...res,
            type: CUSTOM_META_FETCH_ALL,
            status: 'loaded',
            errors: null,
          });
          resolve(res);
        },
        (errors) => {
          dispatch({
            ...emptyState,
            type: CUSTOM_META_FETCH_ALL,
            status: 'error',
            errors,
          });
          reject(errors);
        },
      );
    });
    return p;
  };
}


export function addMeta(params) {
  return (dispatch) => {
    const p = new Promise((resolve, reject) => {
      callApi('custom-metas', 'POST', params).then(
        ({ meta }) => {
          dispatch({ type: CUSTOM_META_ADD_NEW_META, meta, id: meta._id });
          resolve(meta);
        },
        (errors) => {
          reject(errors);
        },
      );
    });
    return p;
  };
}

export function updateMeta(id, params) {
  return (dispatch) => {
    const p = new Promise((resolve, reject) => {
      callApi(`custom-metas/${id}`, 'PUT', params).then(
        ({ meta }) => {
          dispatch({ type: CUSTOM_META_ADD_NEW_META, meta, id });
          resolve(meta);
        },
        (errors) => {
          reject(errors);
        },
      );
    });
    return p;
  };
}

export function deleteMeta(id) {
  return (dispatch) => {
    const p = new Promise((resolve, reject) => {
      callApi(`custom-metas/${id}`, 'DELETE').then(
        (res) => {
          dispatch({ type: CUSTOM_META_DELETE_META, id });
          resolve(res);
        },
        (errors) => {
          reject(errors);
        },
      );
    });
    return p;
  };
}

export function addMetaValue(id, params) {
  return (dispatch) => {
    const p = new Promise((resolve, reject) => {
      callApi(`custom-metas/${id}/values`, 'POST', params).then(
        ({ meta }) => {
          dispatch({ type: CUSTOM_META_ADD_NEW_META, id, meta });
          resolve(meta);
        },
        (errors) => {
          reject(errors);
        },
      );
    });
    return p;
  };
}

export function removeMetaValue(id, value) {
  return (dispatch) => {
    const p = new Promise((resolve, reject) => {
      callApi(`custom-metas/${id}/values/${value}`, 'DELETE').then(
        ({ meta }) => {
          dispatch({ type: CUSTOM_META_ADD_NEW_META, id, meta });
          resolve(meta);
        },
        (errors) => {
          reject(errors);
        },
      );
    });
    return p;
  };
}

export function updateMetaValue(id, value, params) {
  return (dispatch) => {
    const p = new Promise((resolve, reject) => {
      callApi(`custom-metas/${id}/values/${value}`, 'PUT', params).then(
        ({ meta }) => {
          dispatch({ type: CUSTOM_META_ADD_NEW_META, id, meta });
          resolve(meta);
        },
        (errors) => {
          reject(errors);
        },
      );
    });
    return p;
  };
}

export function reorderValues(id, positions) {
  return (dispatch) => {
    const p = new Promise((resolve, reject) => {
      callApi(`custom-metas/${id}/values`, 'PUT', { positions }).then(
        ({ meta }) => {
          dispatch({ type: CUSTOM_META_ADD_NEW_META, id, meta });
          resolve(meta);
        },
        (errors) => {
          reject(errors);
        },
      );
    });
    return p;
  };
}
